import PropTypes from 'prop-types';
import React from 'react';
import connectEditElementToBriefStore from 'contest/components/connected/connect-edit-element-to-brief-store';
import { connectReadElement } from 'contest/components/brief/read-element';
import Button from '@99designs/react-components/components/Button';
import { FormattedMessage } from 'react-intl';

class ViewWebsiteListElement extends React.Component {
    render() {
        return (
            <div>
                {this.props.websites.map((website, i) => {
                    const sanitisedUrl = /^https?:\/\//.test(website.url)
                        ? website.url
                        : 'http://' + website.url;
                    return (
                        <p key={i}>
                            <a className="link" href={sanitisedUrl}>
                                {website.url}
                            </a>
                            <br />
                            {website.comment}
                        </p>
                    );
                })}
            </div>
        );
    }
}

ViewWebsiteListElement.propTypes = {
    websites: PropTypes.arrayOf(
        PropTypes.shape({
            url: PropTypes.string.isRequired,
            comment: PropTypes.string.isRequired,
        })
    ).isRequired,
};

export const ConnectedViewWebsiteListElement = connectReadElement(
    ViewWebsiteListElement,
    element => {
        return { websites: element.value };
    },
    ({ value }) => value.length
);

export class EditWebsiteListElement extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            websites: props.websites,
        };

        this.handleAddWebsite = this.handleAddWebsite.bind(this);
        this.handleChangeWebsite = this.handleChangeWebsite.bind(this);
        this.handleRemoveWebsite = this.handleRemoveWebsite.bind(this);
    }

    render() {
        const lastIndex = this.state.websites.reduceRight((found, website, i) => {
            if (found) {
                return found;
            } else {
                return website ? i : null;
            }
        }, null);

        return (
            <div>
                {this.state.websites.map((website, i, array) => {
                    return this.renderElementForm(website, i, i === lastIndex);
                })}

                {this.renderAddWebsiteButton(lastIndex === null)}
            </div>
        );
    }

    renderElementForm(website, i, last) {
        if (website) {
            return (
                <div className="field" key={i}>
                    <div className="field field--sub-field">
                        <div className="field__title">
                            What websites can designers draw inspiration from?
                        </div>
                        <input
                            className="input-text input-width--max"
                            type="text"
                            defaultValue={website.url}
                            onChange={e => {
                                this.handleChangeWebsite(i, 'url', e.target.value);
                            }}
                            onBlur={this.props.onSave}
                        />
                    </div>

                    <div className="field field--sub-field">
                        <div className="field__title">What do you like about this site?</div>
                        <textarea
                            className="input-textarea input-width--max"
                            rows="4"
                            defaultValue={website.comment}
                            onChange={e => {
                                this.handleChangeWebsite(i, 'comment', e.target.value);
                            }}
                            onBlur={this.props.onSave}
                        />
                    </div>

                    <div className="button-group ">
                        <span className="button-group__item">
                            <Button
                                onClick={() => {
                                    this.handleRemoveWebsite(i);
                                }}
                                variations={['secondary']}
                            >
                                <FormattedMessage id="brief_websitelist_remove_website" />
                            </Button>
                        </span>

                        <span className="button-group__item">
                            {this.renderAddWebsiteButton(last)}
                        </span>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    renderAddWebsiteButton(show) {
        if (show) {
            return (
                <Button
                    onClick={() => {
                        this.handleAddWebsite();
                    }}
                    variations={['secondary']}
                    data="sup"
                >
                    <FormattedMessage id="brief_websitelist_add_website" />
                </Button>
            );
        } else {
            return null;
        }
    }

    handleAddWebsite() {
        let websites = this.state.websites;
        websites.push({
            url: '',
            comment: '',
        });

        this.setState({
            websites: websites,
        });
    }

    handleChangeWebsite(index, element, value) {
        let websites = this.state.websites;
        websites[index] = {
            url: element === 'url' ? value : websites[index].url,
            comment: element === 'comment' ? value : websites[index].comment,
        };

        this.setState(
            {
                websites: websites,
            },
            () => {
                this.updateStore(websites, false);
            }
        );
    }

    handleRemoveWebsite(index) {
        var websites = this.state.websites;
        websites[index] = null;

        this.setState(
            {
                websites: websites,
            },
            () => {
                this.updateStore(websites, true);
            }
        );
    }

    updateStore(websites, saveNow) {
        const validWebsite = website => website && (website.url || website.comment);
        this.props.onChange(websites.filter(validWebsite), saveNow);
    }
}

EditWebsiteListElement.propTypes = {
    websites: PropTypes.arrayOf(
        PropTypes.shape({
            url: PropTypes.string.isRequired,
            comment: PropTypes.string.isRequired,
        })
    ).isRequired,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
};

export const ConnectedEditWebsiteListElement = connectEditElementToBriefStore(
    EditWebsiteListElement,
    element => ({
        websites: element.value,
    })
);



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/website-list-element.jsx